import { FaBalanceScale } from "react-icons/fa";

export const SUPER_ADMIN_DISPUTE_MANAGEMENT_ITEMS = [
  {
    id: "sa_disputes_all",
    label: "All Disputes",
    to: "/super-admin/disputes",
    icon: FaBalanceScale,
    end: true,
    activePathPrefix: "/super-admin/disputes",
  },
];

export const SUPER_ADMIN_DISPUTE_MANAGEMENT_GROUP = {
  id: "dispute_management",
  heading: "Dispute Management",
  icon: FaBalanceScale,
  items: SUPER_ADMIN_DISPUTE_MANAGEMENT_ITEMS,
};
